import React, { useState, useEffect } from "react";
import { notificationsAPI } from "../services/api";
import { useApp } from "../context/AppContext";

export default function NotificationBell() {
  const { currentUser } = useApp();
  const [notifications, setNotifications] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!currentUser) return;
    loadNotifications();
    const interval = setInterval(loadNotifications, 10000);
    return () => clearInterval(interval);
  }, [currentUser?.id]);

  const loadNotifications = async () => {
    try {
      const { notifications } = await notificationsAPI.getMine();
      setNotifications(notifications || []);
    } catch(e) {}
  };

  const unread = notifications.filter(n => !n.read).length;

  const handleOpen = async () => {
    setOpen(!open);
    if (!open && unread > 0) {
      await notificationsAPI.markAllRead();
      setNotifications(prev => prev.map(n => ({ ...n, read: true })));
    }
  };

  const getIcon = (type) => {
    if (type === "new_sale")            return "🛒";
    if (type === "delivery_confirmed")  return "✅";
    if (type === "new_ad")              return "📢";
    if (type === "new_registration" || type === "new_user") return "👤";
    if (type === "new_question")        return "❓";
    if (type === "question_answered")   return "💬";
    if (type === "new_review")          return "⭐";
    if (type === "ad_approved" || type === "ad_active") return "✅";
    if (type === "ad_rejected")         return "❌";
    if (type === "ad_message")          return "📢";
    if (type === "ad_expiring")         return "⏰";
    if (type === "password_reset")      return "🔑";
    if (type === "sale_refunded")       return "↩️";
    if (type === "product_reported")    return "🚩";
    return "🔔";
  };

  return (
    <div style={s.wrap}>
      <button style={s.bell} onClick={handleOpen}>
        🔔
        {unread > 0 && <span style={s.badge}>{unread}</span>}
      </button>

      {open && (
        <div style={s.panel}>
          <div style={s.panelHeader}>
            <p style={s.panelTitle}>Notificaciones</p>
            {unread > 0 && <span style={s.unreadCount}>{unread} nuevas</span>}
          </div>
          {notifications.length === 0 ? (
            <p style={s.empty}>Sin notificaciones</p>
          ) : (
            notifications.map(n => (
              <div key={n.id} style={{...s.item,...(!n.read?s.itemUnread:{})}}>
                <span style={s.itemIcon}>{getIcon(n.type)}</span>
                <div style={s.itemContent}>
                  <p style={s.itemTitle}>{n.title}</p>
                  <p style={s.itemMsg}>{n.message}</p>
                  <p style={s.itemDate}>{new Date(n.created_at).toLocaleString("es-AR", {day:"2-digit",month:"short",hour:"2-digit",minute:"2-digit"})}</p>
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}

const s = {
  wrap:{position:"relative"},
  bell:{background:"none",border:"none",fontSize:22,cursor:"pointer",position:"relative",padding:"4px 8px"},
  badge:{position:"absolute",top:-2,right:-2,background:"#E24B4A",color:"#fff",borderRadius:"50%",width:18,height:18,fontSize:11,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:600},
  panel:{position:"absolute",top:44,right:0,width:320,background:"#fff",borderRadius:12,boxShadow:"0 4px 24px rgba(0,0,0,0.12)",border:"0.5px solid #e0e0e0",zIndex:200,maxHeight:400,overflow:"auto"},
  panelHeader:{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"14px 16px 10px",borderBottom:"0.5px solid #f0f0f0"},
  panelTitle:{fontWeight:600,fontSize:14},
  unreadCount:{fontSize:12,color:"#1D9E75",fontWeight:500},
  empty:{padding:"20px",fontSize:13,color:"#aaa",textAlign:"center"},
  item:{display:"flex",gap:10,padding:"12px 16px",borderBottom:"0.5px solid #f5f5f5",cursor:"pointer"},
  itemUnread:{background:"#f0faf6"},
  itemIcon:{fontSize:20,flexShrink:0},
  itemContent:{flex:1},
  itemTitle:{fontSize:13,fontWeight:600,color:"#111",marginBottom:2},
  itemMsg:{fontSize:12,color:"#555",lineHeight:1.4,marginBottom:4},
  itemDate:{fontSize:11,color:"#aaa"},
};
